// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles pour le composant LotsSelector
 * Sélection des lots techniques et zones géographiques
 */

.lots-selector {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.lots-selector.disabled {
  opacity: 0.7;
  pointer-events: none;
}

.lots-selector.loading,
.lots-selector.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 1rem;
  color: #6b7280;
}

.lots-selector .loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Sections */
.selector-section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  /* border-radius: 0.375rem; */
  overflow: hidden;
}

.selector-header {
  /* background: #595959; */
  padding: 0.75rem 1rem;
  /* border-bottom: 1px solid #e5e7eb; */
}

.selector-header h3 {
  margin: 0 0 0.25rem;
  font-size: 1.4rem;
  font-weight: 600;
  /* color: #ffffff; */
}

.selector-info {
  margin: 0;
  font-size: 1.2rem;
  /* color: rgba(255, 255, 255, 0.8); */
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.info-icon {
  font-size: 1rem;
}

/* Toolbar avec bouton tout sélectionner */
.selector-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem 1.25rem;
  /* background: #fff; */
  border-bottom: 1px solid #f3f4f6;
}

/* Sélection des lots techniques */
.lots-selection {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 10px;
}

.lot-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 1.3rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.lot-select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.lot-select:disabled {
  background: #f9fafb;
  cursor: not-allowed;
}

/* Tags des lots sélectionnés */
.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.75rem;
}

/* Tags de lots cliquables - style cohérent avec inscription */
.lots-selector .lot-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 1rem;
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
  border-radius: 5px;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.lots-selector .lot-tag:hover {
  border-color: #f97316;
  background: #fff7ed;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.15);
}

.lots-selector .lot-tag:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);
}

/* Tag du lot actuellement sélectionné - distinction visuelle forte */
.lots-selector .lot-tag.active {
  background: #f97316 !important;
  color: #ffffff !important;
  border-color: #e5e7eb !important;
}

.lots-selector .lot-tag.active:hover {
  background: #f97316 !important;
  border-color: #e5e7eb !important;
  transform: none;
  box-shadow: none;
}

/* Tag Accord-Cadre - style désactivé */
.lots-selector .lot-tag.ac-tag {
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
}

.lots-selector .lot-tag .lock-icon {
  font-size: 1rem;
}

/* Compteur de zones dans le tag */
.lots-selector .lot-tag .zone-count {
  font-size: 1.1rem;
  opacity: 0.85;
  margin-left: 0.25rem;
}

.lots-selector .lot-tag.active .zone-count {
  color: #374151;
}

/* Bouton de suppression du tag - visible et interactif */
.lots-selector .lot-tag .remove-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  margin-left: 0.375rem;
  transition: background 0.2s;
}

.lots-selector .lot-tag .remove-tag:hover {
  background: rgba(0, 0, 0, 0.2);
}

.lots-selector .lot-tag.active .remove-tag {
  background: rgba(255, 255, 255, 0.25);
}

.lots-selector .lot-tag.active .remove-tag:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Notice AC */
.ac-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 1.2rem;
  color: #374151;
}

.ac-notice .notice-icon {
  flex-shrink: 0;
}

/* Grilles régions et départements */
.regions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.5rem;
  padding: 1.25rem;
}

.departements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.5rem;
  padding: 1.25rem;
  max-height: 400px;
  overflow-y: auto;
}

/* Checkbox régions */
.region-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1.3rem;
  background: white;
}

.region-checkbox:hover:not(.ac-locked) {
  border-color: #f97316;
  background: #fafafa;
}

.region-checkbox.selected {
  border-color: #f97316;
  background: #fafafa;
}

.region-checkbox.ac-locked {
  background: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.7;
}

.region-checkbox.partial-ac {
  border-style: dashed;
}

.region-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
}

.region-checkbox .lock-icon {
  font-size: 1rem;
  margin-left: -0.25rem;
}

.region-checkbox .region-nom {
  flex: 1 1;
  color: #374151;
}

/* Checkbox départements */
.departement-checkbox {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1.2rem;
  background: white;
}

.departement-checkbox:hover:not(.ac-locked) {
  border-color: #f97316;
  background: #fafafa;
}

.departement-checkbox.selected {
  border-color: #f97316;
  background: #fafafa;
}

.departement-checkbox.ac-locked {
  background: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.7;
}

.departement-checkbox input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #f97316;
}

.departement-checkbox .lock-icon {
  font-size: 1rem;
}

.departement-checkbox .dept-code {
  font-weight: 600;
  color: #6b7280;
  min-width: 24px;
}

.departement-checkbox .dept-separator {
  color: #d1d5db;
}

.departement-checkbox .dept-nom {
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Note stockage */
.storage-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: #f3f4f6;
  font-size: 0.75rem;
  color: #6b7280;
  border-top: 1px solid #e5e7eb;
}

.storage-note .note-icon {
  flex-shrink: 0;
}

/* Message aucun lot */
.no-lots-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  text-align: center;
}

.no-lots-notice p {
  margin: 0;
  color: #6b7280;
  font-size: 1rem;
}

/* FRONT-09: Departements verrouilles (AC) */
.departement-checkbox.locked {
  background: #f5f5f5;
  border-color: #d1d5db;
  cursor: not-allowed;
  opacity: 0.8;
}

.departement-checkbox.locked input {
  cursor: not-allowed;
}

.departement-checkbox.locked .locked-indicator {
  font-size: 0.7rem;
  color: #6b7280;
  margin-left: 0.5rem;
  font-weight: 500;
}

.departement-checkbox.locked.selected {
  background: #f0f0f0;
  border-color: #9ca3af;
}

/* ===========================================
   Styles pour les tags de lots cliquables (inscription)
   =========================================== */

/* Container des tags avec espacement ameliore */
.inscription-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.75rem;
}

/* Tags de lots cliquables - style plus gros et visible */
.lots-selector .lot-tag-clickable {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 1rem;
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
  border-radius: 5px;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.lots-selector .lot-tag-clickable:hover {
  border-color: #f97316;
  background: #fff7ed;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.15);
}

.lots-selector .lot-tag-clickable:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);
}

/* Tag du lot actuellement selectionne - distinction visuelle forte */
.lots-selector .lot-tag-active {
  background: #f97316 !important;
  color: #ffffff !important;
  border-color: #e5e7eb !important;
}

.lots-selector .lot-tag-active:hover {
  background: #f97316 !important;
  border-color: #e5e7eb !important;
  transform: none;
  box-shadow: none;
}

/* Compteur de zones dans le tag */
.lots-selector .lot-tag-clickable .zone-count {
  font-size: 1.1rem;
  opacity: 0.85;
  margin-left: 0.25rem;
}

.lots-selector .lot-tag-active .zone-count {
  color: #374151;
}

/* Bouton de suppression du tag */
.lots-selector .lot-tag-clickable .remove-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  margin-left: 0.375rem;
  transition: background 0.2s;
}

.lots-selector .lot-tag-clickable .remove-tag:hover {
  background: rgba(0, 0, 0, 0.2);
}

.lots-selector .lot-tag-active .remove-tag {
  background: rgba(255, 255, 255, 0.25);
}

.lots-selector .lot-tag-active .remove-tag:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Notice pour cliquer sur un lot (cohérence avec inscription) */
.select-lot-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.25rem;
  background: #f0f9ff;
  border: 1px dashed #0ea5e9;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.select-lot-notice .notice-icon {
  flex-shrink: 0;
  margin-right: 0.5rem;
}

.select-lot-notice p {
  margin: 0;
  color: #0369a1;
  font-size: 1.2rem;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .regions-grid {
    grid-template-columns: 1fr;
  }

  .departements-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .lot-tag {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .departements-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/components/LotsSelector.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,qEAAqE;AACrE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;gDAEgD;;AAEhD,gDAAgD;AAChD;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,qEAAqE;AACrE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * Styles pour le composant LotsSelector\n * Sélection des lots techniques et zones géographiques\n */\n\n.lots-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.lots-selector.disabled {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.lots-selector.loading,\n.lots-selector.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  gap: 1rem;\n  color: #6b7280;\n}\n\n.lots-selector .loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Sections */\n.selector-section {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  /* border-radius: 0.375rem; */\n  overflow: hidden;\n}\n\n.selector-header {\n  /* background: #595959; */\n  padding: 0.75rem 1rem;\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.selector-header h3 {\n  margin: 0 0 0.25rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  /* color: #ffffff; */\n}\n\n.selector-info {\n  margin: 0;\n  font-size: 1.2rem;\n  /* color: rgba(255, 255, 255, 0.8); */\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.info-icon {\n  font-size: 1rem;\n}\n\n/* Toolbar avec bouton tout sélectionner */\n.selector-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.75rem 1.25rem;\n  /* background: #fff; */\n  border-bottom: 1px solid #f3f4f6;\n}\n\n/* Sélection des lots techniques */\n.lots-selection {\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-radius: 10px;\n}\n\n.lot-select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.25rem;\n  font-size: 1.3rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.lot-select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.lot-select:disabled {\n  background: #f9fafb;\n  cursor: not-allowed;\n}\n\n/* Tags des lots sélectionnés */\n.selected-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n/* Tags de lots cliquables - style cohérent avec inscription */\n.lots-selector .lot-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.625rem 1rem;\n  background: #f3f4f6;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  border-radius: 5px;\n  font-size: 1.3rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.lots-selector .lot-tag:hover {\n  border-color: #f97316;\n  background: #fff7ed;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.15);\n}\n\n.lots-selector .lot-tag:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);\n}\n\n/* Tag du lot actuellement sélectionné - distinction visuelle forte */\n.lots-selector .lot-tag.active {\n  background: #f97316 !important;\n  color: #ffffff !important;\n  border-color: #e5e7eb !important;\n}\n\n.lots-selector .lot-tag.active:hover {\n  background: #f97316 !important;\n  border-color: #e5e7eb !important;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Tag Accord-Cadre - style désactivé */\n.lots-selector .lot-tag.ac-tag {\n  background: #f3f4f6 !important;\n  color: #9ca3af !important;\n  border-color: #d1d5db !important;\n}\n\n.lots-selector .lot-tag .lock-icon {\n  font-size: 1rem;\n}\n\n/* Compteur de zones dans le tag */\n.lots-selector .lot-tag .zone-count {\n  font-size: 1.1rem;\n  opacity: 0.85;\n  margin-left: 0.25rem;\n}\n\n.lots-selector .lot-tag.active .zone-count {\n  color: #374151;\n}\n\n/* Bouton de suppression du tag - visible et interactif */\n.lots-selector .lot-tag .remove-tag {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  font-size: 1.1rem;\n  font-weight: bold;\n  line-height: 1;\n  cursor: pointer;\n  color: inherit;\n  margin-left: 0.375rem;\n  transition: background 0.2s;\n}\n\n.lots-selector .lot-tag .remove-tag:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.lots-selector .lot-tag.active .remove-tag {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.lots-selector .lot-tag.active .remove-tag:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n/* Notice AC */\n.ac-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 1.2rem;\n  color: #374151;\n}\n\n.ac-notice .notice-icon {\n  flex-shrink: 0;\n}\n\n/* Grilles régions et départements */\n.regions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.5rem;\n  padding: 1.25rem;\n}\n\n.departements-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.5rem;\n  padding: 1.25rem;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Checkbox régions */\n.region-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 0.75rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 1.3rem;\n  background: white;\n}\n\n.region-checkbox:hover:not(.ac-locked) {\n  border-color: #f97316;\n  background: #fafafa;\n}\n\n.region-checkbox.selected {\n  border-color: #f97316;\n  background: #fafafa;\n}\n\n.region-checkbox.ac-locked {\n  background: #f3f4f6;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.region-checkbox.partial-ac {\n  border-style: dashed;\n}\n\n.region-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n}\n\n.region-checkbox .lock-icon {\n  font-size: 1rem;\n  margin-left: -0.25rem;\n}\n\n.region-checkbox .region-nom {\n  flex: 1;\n  color: #374151;\n}\n\n/* Checkbox départements */\n.departement-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 0.625rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 1.2rem;\n  background: white;\n}\n\n.departement-checkbox:hover:not(.ac-locked) {\n  border-color: #f97316;\n  background: #fafafa;\n}\n\n.departement-checkbox.selected {\n  border-color: #f97316;\n  background: #fafafa;\n}\n\n.departement-checkbox.ac-locked {\n  background: #f3f4f6;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.departement-checkbox input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: #f97316;\n}\n\n.departement-checkbox .lock-icon {\n  font-size: 1rem;\n}\n\n.departement-checkbox .dept-code {\n  font-weight: 600;\n  color: #6b7280;\n  min-width: 24px;\n}\n\n.departement-checkbox .dept-separator {\n  color: #d1d5db;\n}\n\n.departement-checkbox .dept-nom {\n  color: #374151;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Note stockage */\n.storage-note {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.25rem;\n  background: #f3f4f6;\n  font-size: 0.75rem;\n  color: #6b7280;\n  border-top: 1px solid #e5e7eb;\n}\n\n.storage-note .note-icon {\n  flex-shrink: 0;\n}\n\n/* Message aucun lot */\n.no-lots-notice {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: #f9fafb;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.no-lots-notice p {\n  margin: 0;\n  color: #6b7280;\n  font-size: 1rem;\n}\n\n/* FRONT-09: Departements verrouilles (AC) */\n.departement-checkbox.locked {\n  background: #f5f5f5;\n  border-color: #d1d5db;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.departement-checkbox.locked input {\n  cursor: not-allowed;\n}\n\n.departement-checkbox.locked .locked-indicator {\n  font-size: 0.7rem;\n  color: #6b7280;\n  margin-left: 0.5rem;\n  font-weight: 500;\n}\n\n.departement-checkbox.locked.selected {\n  background: #f0f0f0;\n  border-color: #9ca3af;\n}\n\n/* ===========================================\n   Styles pour les tags de lots cliquables (inscription)\n   =========================================== */\n\n/* Container des tags avec espacement ameliore */\n.inscription-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n/* Tags de lots cliquables - style plus gros et visible */\n.lots-selector .lot-tag-clickable {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.625rem 1rem;\n  background: #f3f4f6;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  border-radius: 5px;\n  font-size: 1.3rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.lots-selector .lot-tag-clickable:hover {\n  border-color: #f97316;\n  background: #fff7ed;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.15);\n}\n\n.lots-selector .lot-tag-clickable:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);\n}\n\n/* Tag du lot actuellement selectionne - distinction visuelle forte */\n.lots-selector .lot-tag-active {\n  background: #f97316 !important;\n  color: #ffffff !important;\n  border-color: #e5e7eb !important;\n}\n\n.lots-selector .lot-tag-active:hover {\n  background: #f97316 !important;\n  border-color: #e5e7eb !important;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Compteur de zones dans le tag */\n.lots-selector .lot-tag-clickable .zone-count {\n  font-size: 1.1rem;\n  opacity: 0.85;\n  margin-left: 0.25rem;\n}\n\n.lots-selector .lot-tag-active .zone-count {\n  color: #374151;\n}\n\n/* Bouton de suppression du tag */\n.lots-selector .lot-tag-clickable .remove-tag {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  font-size: 1.1rem;\n  font-weight: bold;\n  line-height: 1;\n  cursor: pointer;\n  color: inherit;\n  margin-left: 0.375rem;\n  transition: background 0.2s;\n}\n\n.lots-selector .lot-tag-clickable .remove-tag:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.lots-selector .lot-tag-active .remove-tag {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.lots-selector .lot-tag-active .remove-tag:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n/* Notice pour cliquer sur un lot (cohérence avec inscription) */\n.select-lot-notice {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.25rem;\n  background: #f0f9ff;\n  border: 1px dashed #0ea5e9;\n  border-radius: 0.5rem;\n  margin-top: 1rem;\n}\n\n.select-lot-notice .notice-icon {\n  flex-shrink: 0;\n  margin-right: 0.5rem;\n}\n\n.select-lot-notice p {\n  margin: 0;\n  color: #0369a1;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .regions-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .departements-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .lot-tag {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .departements-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
